import React, { useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import { languageHelper } from "../../../../config/helperFunctions";



function ReturnReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN") || "SN",
      accessorKey: "SN",
    },
    {
      header: languageHelper("Reference No") || "Reference No",
      accessorKey: "Reference No",
    },
    {
      header: languageHelper("Date") || "Date",
      accessorKey: "Date",
    },

    {
      header: languageHelper("Amount") || "Amount",
      accessorKey: "Amount",
    },
    {
      header: languageHelper("Vat") || "Vat",
      accessorKey: "Vat",
    },
    {
      header: languageHelper("Total Amount") || "Total Amount",
      accessorKey: "Total amount",
    },
    {
      header: languageHelper("Description") || "Description",
      accessorKey: "Description",
    },
  ];
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedOutlet, setSelectedOutlet] = useState();
  const handleOutletSelect = (e) => {
    setSelectedOutlet(e.value);
  };

  const footerConfig = {
    [languageHelper("SN")]: languageHelper("Total") || "Total",
    [languageHelper("Amount")]: (rows) =>
      rows.reduce((acc, row) => acc + (Number(row.Amount) || 0), 0).toFixed(2),
    [languageHelper("Vat")]: (rows) =>
      rows.reduce((acc, row) => acc + (Number(row.Vat) || 0), 0).toFixed(2),
    [languageHelper("Total Amount")]: (rows) =>
      rows.reduce((acc, row) => acc + (Number(row["Total amount"]) || 0), 0).toFixed(2),
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/return-report`, {
        headers: {
          Authorization: `Bearer ${user?.token}`
        },
        params: {
          outletId: selectedOutlet,
          from: startDate,
          to: endDate,
        },
      })
      .then((res) => {
        const formattedData = res.data.map((item, index) => ({
          SN: index + 1,
          "Reference No": item.ref_no,
          Date: new Date(item.created_at).toLocaleDateString(),
          Amount: item.return_amount,
          Vat: item.return_vat,
          "Total amount": item.total_return_amount,
          Description: item.description,
        }));
        setData(formattedData);
      });
  }, [endDate, selectedOutlet, startDate, user?.token]);

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Return Report") || "Return Report"}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        downloads={true}
        dateTime={true}
        handleOutletSelect={handleOutletSelect}
        showFooter={true}
        footerConfig={footerConfig}
      />
    </main>
  );
}

export default ReturnReport;
